import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_1Screen } from "../SlotGameType1_1Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import { IcyFresh_1Screen } from "../IcyFresh/game_1Screen";

// namespace SlotGames {

    export class IcyFreshLink_1Screen extends IcyFresh_1Screen {
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "IcyFreshLink");
        }
    }
